module.exports = __webpack_public_path__ + "img/liangguangmozhenxingdai.min.00580e96.png";